import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

const ModalRoute = ({ children, title, getBackPage }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

  const handleClose = () => {
    if(getBackPage) {
      navigate(getBackPage);
    } else {
      navigate(-1); // Go back to the previous page
    }
    
  };

  return (
    <Modal className='cd_cnt_modal' show='true' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default ModalRoute;
